import { AppFundaBrochureRequestPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../../../constants';

export default (): AppFundaBrochureRequestPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.EVENT_CONTACT_APP_FUNDA_BROCHUREREQUEST_POINTER,
  variable: null,
});
